import { render, staticRenderFns } from "./MantenedorTelcosBase.vue?vue&type=template&id=3127eb7d&"
import script from "./MantenedorTelcosBase.vue?vue&type=script&lang=ts&"
export * from "./MantenedorTelcosBase.vue?vue&type=script&lang=ts&"
import style0 from "./MantenedorTelcosBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports